<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-9">
                            <h5 class="card-title mb-4">Menus</h5>
                        </div>
                        <div class="col-md-3">
                            <button class="btn btn-primary btn-block"
                                            @click="handleBtnNew">
                                <i class="mdi mdi-plus"></i>Add New Menu
                            </button>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table center-aligned-table">
                            <thead>
                                <tr>
                                    <th class="border-bottom-0">No.</th>
                                    <th class="border-bottom-0">Name</th>
                                    <th class="border-bottom-0">Description</th>
                                    <th class="border-bottom-0"></th>
                                    <th class="border-bottom-0"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, index) in menus">
                                    <td> {{ index + 1 }} </td>
                                    <td> {{ c.menuName }} </td>
                                    <td> {{ c.description }} </td>
                                    <td>
                                        <b-button-group>
                                            <b-button variant="primary" 
                                                      class="icon-btn"
                                                      v-on:click="handleBtnEdit(c)">
                                                <i class="mdi mdi-table-edit"></i>
                                            </b-button>
                                            <b-button variant="danger" 
                                                      class="icon-btn"
                                                      v-on:click="handleBtnDelete(c)">
                                                <i class="mdi mdi-delete-forever"></i>
                                            </b-button>
                                        </b-button-group>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapActions, mapState } from'vuex'
import RestaurantChangedBase from '../Bases/RestaurantChangedBase'
export default{
    name: 'menus',
    extends: RestaurantChangedBase,
    computed: {
        ...mapState({
             menus: state => state.menus.menus
        })
    },
    methods: {
        handleBtnNew() {
            this.$router.push( { name: 'menuaddform' });
        },
        handleBtnEdit(menu) {
            this.$router.push( {name: 'menueditform', params: { id: menu.menuId } });
        },
        handleBtnDelete(menu) {
            this.$store.dispatch('menus/deleteMenuAction', menu.menuId);
        }
    },
    async created() {
        await this.$store.dispatch('restaurants/getRestaurantsAction');
        this.$store.dispatch('menus/getMenusAction');
        this.setAction('menus/getMenusAction');
    }
}
</script>

<style lang="scss">
   
</style>